// file: src/utils/fileUtils.js

/**
 * Detects the file type based on its extension.
 * @param {string} fileName - The name of the file.
 * @returns {string} The detected file type ('pdf', 'csv', 'doc', 'blender', 'freecad', 'jupyterlab', 'kicad', 'unknown').
 */
export function detectFileType(fileName) {
  if (!fileName) return 'unknown';

  // Check for Blender virtual files
  if (fileName.includes('Blender:') || fileName.includes('.blender')) {
    return 'blender';
  }

  // Check for FreeCAD virtual files
  if (fileName.includes('FreeCAD:') || fileName.includes('.freecad')) {
    return 'freecad';
  }

  // Check for JupyterLab virtual files
  if (fileName.includes('JupyterLab:') || fileName.includes('.jupyterlab')) {
    return 'jupyterlab';
  }

  // Check for KiCad virtual files
  if (fileName.includes('KiCad:') || fileName.includes('.kicad')) {
    return 'kicad';
  }

  const parts = fileName.split('.');
  const ext = parts.length > 0 ? parts.pop().toLowerCase() : '';
  if (!ext) return 'unknown';
  
  switch (ext) {
    case 'pdf':
      return 'pdf';
    case 'csv':
      return 'csv';
    case 'doc':
    case 'docx':
      return 'doc';
    default:
      return 'unknown';
  }
} 